export const API_PATH = "graphql/";
export const PAGE_SIZE = 10;
